// ===== Packages =====

import styled                       from 'styled-components';

// ===== Constants =====

import {
    BODY_FONT_SIZE,
}                                   from '../../constants/generalConstants';
import FONT_TYPE                    from '../../constants/fontType';

const HEADER_HEIGHT = 90;

export const Container = styled.div`
    width: 100%;
    height: auto;
    min-height: 100vh;
    min-height: 100svh;
    min-height: 100dvh;
    background: ${({ theme }) => theme.verascopeColor.orange100};
`;

export const AboutTextContainer = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    min-height: 100vh;
    min-height: 100svh;
    min-height: 100dvh;
    padding: ${`${1.25 * BODY_FONT_SIZE}px ${1.875 * BODY_FONT_SIZE}px`};
    padding-top: ${`${HEADER_HEIGHT + 3.125 * BODY_FONT_SIZE}px`};
    padding-bottom: ${`${3.75 * BODY_FONT_SIZE}px`};
`;

interface AboutTextProps {
    isVisible: boolean,
    delay: number,
    enterDuration: number,
    marginTop?: boolean,
}
export const AboutText = styled.p<AboutTextProps>`
    position: relative;
    top: ${({ isVisible }) => `${isVisible ? 0 : 2.5 * BODY_FONT_SIZE}px`};
    font-family: ${FONT_TYPE.PRESS_START};
    font-size: 1.1em;
    font-weight: 400;
    color: ${({ theme }) => theme.color.white};
    line-height: 2em;
    max-width: 40ch;
    margin: 0 auto;
    margin-top: ${({ marginTop }) => `${marginTop ? 2.5 * BODY_FONT_SIZE : 0}px`};
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    pointer-events: none;
    transition: ${({
        enterDuration,
        delay,
        theme,
    }) => `
        top ${enterDuration}ms ${delay}ms ${theme.motion.overshoot},
        opacity ${enterDuration}ms ${delay}ms ${theme.motion.eagerEasing}
    `};

    ${({ theme }) => theme.mediaQuery.small} {
        font-size: 1em;
    }

    ${({ theme }) => theme.mediaQuery.extraSmall} {
        font-size: 0.9em;
    }
`;

interface ColorTextProps {
    color: string,
}
export const ColorText = styled.span<ColorTextProps>`
    color: ${({ color }) => color};
`;
